import { z } from 'zod';
import { schemas } from 'packages/tackle-api/src/co-sell-msft/solutions';

/** schema to transform Solutions api data to
 *  the selected solutions data fields used in the form
 */
export const SolutionsFromApiToFormValuesTransform = z
  .array(schemas.SolutionSchema)
  .transform((solutions) =>
    solutions.map((solution) => ({
      id: solution.solutionId,
      name: solution.name,
      publisherName: solution.publisherName,
      solutionType: solution.solutionType,
      type: 'Name' as const,
    })),
  );

export type SolutionsFromApiType = z.input<
  typeof SolutionsFromApiToFormValuesTransform
>;

export type SolutionTransformedFormValues = z.infer<
  typeof SolutionsFromApiToFormValuesTransform
>;
